<template>
	<div class="page_content">
		<h3>{{$route.query.id?'编辑规则':'新增规则'}}</h3>
		<a-divider />
		<div class="page_edit_content">
			<a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">

				<div class="flex_box">
					<div>
						<h4>基础信息</h4>
						<a-form-item required label="适用工厂">
							<p v-if='$route.query.id'>{{form.factory_name}}</p>
							<a-select  v-else  ref="select" v-model:value="form.factory_id">
								<a-select-option :value="fact.id" v-for='(fact,factindex) in factoryList'
									:key='fact.id'>{{fact.label}}</a-select-option>
							</a-select>
							
							
						</a-form-item>
						<a-form-item label="工厂ID">
							<p>{{form.factory_id?form.factory_id:'根据所选工厂，展示对应的工厂ID'}}</p>
						</a-form-item>
						
						<a-form-item label="工厂地址">
							<a-input placeholder='请填写工厂地址' v-model:value="form.address" />
							<p>在下方地图中输入地址后点击"地图定位"自动获取 GPS 坐标</p>
						</a-form-item>
					</div>
					<div>
						<h4>地址围栏配置</h4>
						<a-form-item required label="GPS中心点">
							<p>或者选择下方地图选点自动填充</p>
						</a-form-item>
						<a-form-item required label="经度">
							<a-input placeholder='如:12.33344' v-model:value="form.longitude" />
						</a-form-item>
						<a-form-item required label="纬度">
							<a-input placeholder='如:12.33344' v-model:value="form.latitude" />
						</a-form-item>
						<a-form-item required label="允许打卡半径">
							<a-input placeholder='100' suffix='米' v-model:value="form.radius" />
							<p>建议 300-500 米，信号弱的工厂可适当放宽</p>
						</a-form-item>
					</div>
				</div>
				<div style="padding-bottom:20px" class="map_select">
					<simple-map  :radius="form.radius"  @get_title="get_title"></simple-map>
				</div>
				<a-divider />
				<h4>驻场规则配置</h4>
				<a-form-item required label="旺季设置">
					<a-radio-group v-model:value="form.peak_open">
						<a-radio :value="1">设定旺季</a-radio>
						<a-radio :value="0">不设定旺季</a-radio>
					</a-radio-group>
				</a-form-item>
				<a-form-item v-if='form.peak_open==1' required label="旺季时间">
					<a-radio-group v-model:value="form.peak_month_type">
						<a-radio :value="1">系统默认旺季</a-radio>
						<a-radio :value="2">自定义旺季</a-radio>
					</a-radio-group>
					<a-select v-if='form.peak_month_type==2' ref="select" mode="multiple"
						v-model:value="form.peak_months">
						<a-select-option :value="month" v-for='month in 12' :key='month'>{{month}}月</a-select-option>
					</a-select>
					<div v-if='form.peak_month_type==1'>
					<div v-if='system_peak_months.length>0'> 
					<a-tag v-for='mon in system_peak_months'>{{mon}}月</a-tag>
					</div>
					<div v-else>
					当前暂未设置系统默认旺季
					</div>
					</div>
				</a-form-item>

				<a-form-item required label="晚班设置">
					<a-radio-group v-model:value="form.night_open">
						<a-radio :value="1">启用晚班</a-radio>
						<a-radio :value="0">不启用晚班</a-radio>
					</a-radio-group>
				</a-form-item>
				<div v-if='form.peak_open==0'>
					<a-alert message="打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<a-form-item required :label="form.night_open==1?'白班时间':'上班时间'">
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.off_day_start" valueFormat="HH:mm" />~
						<a-time-picker style='width:25%'  format="HH:mm" v-model:value="form.off_day_end" valueFormat="HH:mm" />
					</a-form-item>

					<a-form-item v-if='form.night_open==1' required label="晚班时间">
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.off_night_start" valueFormat="HH:mm" />~
						<a-time-picker style='width:25%'  format="HH:mm" v-model:value="form.off_night_end" valueFormat="HH:mm" />
					</a-form-item>

					<a-form-item required label="打卡频率">
						<a-input style='width:40%'  addonAfter="小时打卡1次" type="number"  v-model:value="form.off_frequency" />
					</a-form-item>
				</div>

				<div v-if='form.peak_open==1'>
					<a-alert message="旺季打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>
					<a-form-item required :label="form.night_open==1?'旺季白班时间':'旺季上班时间'">
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.peak_day_start" valueFormat="HH:mm" />~
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.peak_day_end" valueFormat="HH:mm" />
					</a-form-item>

					<a-form-item v-if='form.night_open==1' required label="旺季晚班时间">
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.peak_night_start"
							valueFormat="HH:mm" />~
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.peak_night_end" valueFormat="HH:mm" />
					</a-form-item>


					<a-form-item required label="旺季打卡频率">
						<a-input style='width:50%' addonAfter="小时打卡1次" addonBefore="每" type="number" 
							v-model:value="form.peak_frequency" />
					</a-form-item>

					<a-alert message="淡季打卡规则" banner type="info" show-icon>
						<template #icon><a-icon type="caret-right" /></template>
					</a-alert>

					<a-form-item required :label="form.night_open==1?'淡季白班时间':'淡季上班时间'">
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.off_day_start" valueFormat="HH:mm" />~
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.off_day_end" valueFormat="HH:mm" />
					</a-form-item>

					<a-form-item required label="淡季晚班时间" v-if='form.night_open == 1'>
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.off_night_start" valueFormat="HH:mm" />~
						<a-time-picker style='width:25%' format="HH:mm" v-model:value="form.off_night_end" valueFormat="HH:mm" />
					</a-form-item>

					<a-form-item required label="淡季打卡频率">
						<a-input style='width:50%'  type="number" addonAfter="小时打卡1次" addonBefore="每"
							v-model:value="form.off_frequency" />
					</a-form-item>

				</div>




				<a-alert message="其他规则" banner type="info" show-icon>
					<template #icon><a-icon type="caret-right" /></template>
				</a-alert>


				<a-form-item required label="容错窗口">
					<a-input style='width:40%' addonBefore="前后" addonAfter="分钟" type="number"
						v-model:value="form.tolerance" />
					<p>容错期内打卡视为合规，超出容错期，则不可打卡</p>
				</a-form-item>


			</a-form>






			<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
				<a-button type="primary" @click='handleSubmit'>
					保存
				</a-button>
				
				<a-button type="defalut" style='margin-left:60px;' @click="$router.back()">返回</a-button>
			</a-form-item>
			</a-form>
		</div>
	</div>
</template>

<script>
	import Map from "@/components/EditPop";
	import SimpleMap from "@/components/BaiduMap";

	import Form from "@/components/Form";
	import {
		message
	} from 'ant-design-vue'
	import {
		post_user
	} from '@/api/api'
	import TransferTree from "@/components/TransferTreeTwo";

	import {
		saveRuleInfo,
		getRuleDetail,
		getPeakConfig
	} from "@/api/dispatch";
	import {
		getFactorySelect
	} from "@/api/qms";
	export default {
		components: {
			Form,
			TransferTree,
			SimpleMap,
			Map
		},
		data() {
			return {
				system_peak_months:[],
				night_end_time: '',
				day_start_time: '',
				day_end_time: '',
				night_start_time: '',
				treeData: [],
				rule_user: [],
				treeDataValue: [],
				expand: false,
				loading: true,
				status: false,
				datas: {},
				form: {},
				map: {},
				factoryList: [],
				factory_id_name: '',


			};
		},
		created() {
			getFactorySelect({
				is_page: 0
			}).then(res => {
				this.factoryList = res.data.list
			})
			this.$nextTick(() => {
				if (this.$route.query.id) {
					this.edit(this.$route.query)
					
				}else{
					this.getPeakConfigFun()
				}
			})
		},
		methods: {
getPeakConfigFun() {
				getPeakConfig().then(res => {
					this.system_peak_months = res.data.peak_months
				})
			},
			get_title(e) {
				let map = {
					address_name: e.title,
					longitude: e.point.lng,
					latitude: e.point.lat,
					address: e.address
				};
				this.form.longitude =e.point.lng,
				this.form.latitude =e.point.lat,
				this.form.address = e.title + e.address
				this.map = map;
				this.$forceUpdate()
			},

			TransferTreeChange(value) {
				this.rule_user = value.join(',')
			},
			edit(record) {
				getRuleDetail({
					data: {
						id: record.id
					}
				}).then(res => {
					this.form = res.data
					this.system_peak_months = res.data.system_peak_months
				})
			},
			handleSubmit(e) {
				saveRuleInfo({
					data: {
						...this.form,
						status: this.status ? 1 : -1,
					},
					info: true,
				}).then(res => {
					this.$router.back()
				})
			},
			handleInput(fieldName) {
				if (this.form[fieldName] < 0) {
					this.form[fieldName] = 0;
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	.map_select {
		position: relative;
		margin: 0px 10%;
		border: 1px solid #eee;
		padding: 16px;
		border-radius: 8px;

		.serach_input {
			position: absolute;
			top: 20px;
			left: 20px;
		}
	}

	ul {
		padding: 0;
	}

	li {
		display: block;
		list-style: none;
		display: flex;

		span {
			padding-right: 10px;

			display: inline-block;
		}
	}

	.avatar-uploader>.ant-upload {
		width: 128px;
		height: 128px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.spin-content {
		border: 1px solid #91d5ff;
		background-color: #e6f7ff;
		padding: 30px;
	}

	.distributor {
		width: 60%;
		margin-left: 1.5%;
		padding: 5px 10px;
		padding-bottom: 10px;
	}

	.distributor_box {
		background-color: rgba(250, 250, 250, 1);
		margin-left: 14%;
		padding-bottom: 20px;

		.title {
			margin-left: 24px;
		}

		/deep/.ant-col-5 {
			width: 7%;
		}
	}

	.page_content .ant-col-19 {
		width: 34.166667% !important;
	}

	/deep/ .ant-input-affix-wrapper {
		.ant-input:not(:last-child) {
			padding-right: 45px;
		}
	}

	/deep/ .ant-alert-message {
		color: #1890ff;
	}


	/deep/ .ant-alert-icon {
		top: 10px;
	}

	.flex_box {
		display: flex;

		div {
			flex: 1
		}
	}
</style>